"use client";
import {
  useCompositeItem
} from "./P2CTZE2T.js";
import {
  useToolbarContext
} from "./A3WPL2ZJ.js";
import {
  createElement,
  createHook,
  forwardRef,
  memo
} from "./LMDWO4NN.js";
import {
  __objRest,
  __spreadValues
} from "./3YLGPPWQ.js";

// src/toolbar/toolbar-item.tsx
var TagName = "button";
var useToolbarItem = createHook(
  function useToolbarItem2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useToolbarContext();
    store = store || context;
    props = useCompositeItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarItem = memo(
  forwardRef(function ToolbarItem2(props) {
    const htmlProps = useToolbarItem(props);
    return createElement(TagName, htmlProps);
  })
);

export {
  useToolbarItem,
  ToolbarItem
};
